import _pt from '../../../node_modules/prop-types/index.js';

var maxLength = function maxLength() {
  return {
    propTypes: {
      maxLength: _pt.number,
      maxLengthError: _pt.string
    },
    shouldValidate: function shouldValidate(props) {
      return typeof props.maxLength === "number" && props.maxLength > 0;
    },
    getErrors: function getErrors(field, value, props) {
      if (typeof value === "string" || Array.isArray(value)) {
        var length = value.length;

        if (props.maxLength !== undefined && length > props.maxLength) {
          var subject = typeof value === "string" ? "character" : "item";
          return [props.maxLengthError || "".concat(field, " cannot have more than ").concat(props.maxLength, " ").concat(subject).concat(props.maxLength === 1 ? "" : "s")];
        }
      }

      return [];
    }
  };
};

export { maxLength };
